import { useContext } from "react";
import { ToastContext } from "../context/ToastContext";

export const useToastContext = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error("useToast must be used inside ToastProvider");
  }

  return context;
};
